export { TO_C_HOME_URL } from "@common/ict/model/data/index";
export { TO_C_HEAD } from "@common/ict/model/data/index";

import { STORAGE_CONFIG } from "@common/model";
// 在这一层统一所有项目的token  userInfo

export const ICT_USER_INFO = STORAGE_CONFIG.LOGIN_USER;
